import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ErrorPage from 'containers/pages/ErrorPage'
import routes from './route'

export function NotFound() {
  return (
    <Status code={404}>
      <div />
    </Status>
  )
}

function Status({ code, children }) {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) {
          staticContext.status = code
        }
        return children
      }}
    />
  )
}

export function routeIndexes(service) {
  const indexes = {
    www: routes,
  }
  return indexes[service]
}

export function serviceRouter(service, ssr = true, errorStatus = null) {
  return () => (
    <Switch>
      {errorStatus && <ErrorPage status={errorStatus} />}
      {routeIndexes(service).map((route, index) => (
        <Route key={index} {...route} />
      ))}
      {ssr ? (
        <Route component={NotFound} />
      ) : (
        <ErrorPage status={errorStatus} />
      )}
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/routes/index.jsx